import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';

import { BillingDetails } from '../types';

export const getBillingDetails = ({ groupId }: { groupId: string }): Promise<BillingDetails> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'billing/details/' + groupId;

  return axios
    .get(endPoint, {
      validateStatus: (status) => status < 500,
    })
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      if (response?.status === 404) {
        return {
          groupId: groupId,
          alreadySaved: false,
        };
      }

      response.alreadySaved = false;
      if (response?.companyCif && response?.companyCifDocumentType) {
        response.alreadySaved = true;
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};
